import { render, staticRenderFns } from "./purchase-list.vue?vue&type=template&id=743c3147&scoped=true&"
import script from "./purchase-list.vue?vue&type=script&lang=ts&"
export * from "./purchase-list.vue?vue&type=script&lang=ts&"
import style0 from "./purchase-list.vue?vue&type=style&index=0&id=743c3147&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743c3147",
  null
  
)

export default component.exports